import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import {
  useEditPlanzoneSettings,
  useRetrievePlanzoneSettings,
} from "@planzone/view-models";
import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function TimeAllocation({ planzone }: Props) {
  const { t } = useTranslation();
  const { settings } = useRetrievePlanzoneSettings(planzone);
  const { editPlanzoneSettings } = useEditPlanzoneSettings(planzone);

  return (
    <div className={styles.timeAllocation}>
      <p className={styles.description}>
        {t("planzoneParametersPage.timeAllocation.description")}
      </p>
      <div className={styles.boxes}>
        <div className={classNames(styles.box, { [styles.boxInput]: false })} />
        <div className={classNames(styles.box, { [styles.boxInput]: false })}>
          <p>{t("planzoneParametersPage.timeAllocation.personalTimeSheet")}</p>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: false })}>
          <p>{t("planzoneParametersPage.timeAllocation.groupTimeSheet")}</p>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: false })}>
          <p>{t("planzoneParametersPage.timeAllocation.managerTimeSheet")}</p>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          {t("planzoneParametersPage.timeAllocation.entry")}
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          <div
            onClick={() =>
              editPlanzoneSettings({
                planzone,
                settings,
                nextSettings: {
                  ...settings,
                  canEditPersonalTimeSheet: !settings.canEditPersonalTimeSheet,
                },
              })
            }
          >
            <Checkbox isChecked={settings.canEditPersonalTimeSheet} />
          </div>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          <div
            onClick={() =>
              editPlanzoneSettings({
                planzone,
                settings,
                nextSettings: {
                  ...settings,
                  canEditProjectPersonalTimeSheet:
                    !settings.canEditProjectPersonalTimeSheet,
                },
              })
            }
          >
            <Checkbox isChecked={settings.canEditProjectPersonalTimeSheet} />
          </div>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          <div
            onClick={() =>
              editPlanzoneSettings({
                planzone,
                settings,
                nextSettings: {
                  ...settings,
                  canEditManagerPersonalTimeSheet:
                    !settings.canEditManagerPersonalTimeSheet,
                },
              })
            }
          >
            <Checkbox isChecked={settings.canEditManagerPersonalTimeSheet} />
          </div>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          {t("planzoneParametersPage.timeAllocation.approval")}
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          <div
            onClick={() =>
              editPlanzoneSettings({
                planzone,
                settings,
                nextSettings: {
                  ...settings,
                  canApprovePersonalTimeSheet:
                    !settings.canApprovePersonalTimeSheet,
                },
              })
            }
          >
            <Checkbox isChecked={settings.canApprovePersonalTimeSheet} />
          </div>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          <div
            onClick={() =>
              editPlanzoneSettings({
                planzone,
                settings,
                nextSettings: {
                  ...settings,
                  canApproveProjectPersonalTimeSheet:
                    !settings.canApproveProjectPersonalTimeSheet,
                },
              })
            }
          >
            <Checkbox isChecked={settings.canApproveProjectPersonalTimeSheet} />
          </div>
        </div>
        <div className={classNames(styles.box, { [styles.boxInput]: true })}>
          <div
            onClick={() =>
              editPlanzoneSettings({
                planzone,
                settings,
                nextSettings: {
                  ...settings,
                  canApproveManagerPersonalTimeSheet:
                    !settings.canApproveManagerPersonalTimeSheet,
                },
              })
            }
          >
            <Checkbox isChecked={settings.canApproveManagerPersonalTimeSheet} />
          </div>
        </div>
      </div>
    </div>
  );
}

export { TimeAllocation };
